<template>
  <CContainer fluid>
    <CDataTable 
      hover 
      :items="items" 
      :fields="fields">
      <template #descripcion="{item}">
        <td>
          <h4>{{ item.Descripcion }}</h4>
        </td>
      </template>
      <template #valores="{item}">
        <td>
          <div>
            <i class="bi bi-cart3 h5 text-s3green mr-1"></i>
            <span>${{ formatter.format(item.Valor_Mercancia, 0) }}</span>
          </div>
          <div>
            <i class="bi bi-cash-stack h5 text-warning mr-1"></i>
            <span>${{ formatter.format(item.Valor_Costo, 0) }}</span>
          </div>
        </td>
      </template>
      <template #utilidades="{item}">
        <td>
          <div>
            <i class="bi bi-graph-up-arrow h4 text-info"></i>
            <span class="font-weight-bold h4 ml-1">{{ item.Porcentaje_Utilidad }}%</span>
          </div>
          <div>
            <span class="font-weight-bold">${{ formatter.format(item.Valor_Utilidad, 0) }}</span>
          </div>
        </td>
      </template>
      <template #presupuesto="{item}">
        <td>
          <div v-if="reportType == 'G' || reportType == 'V'">
            <span>
              <i class="bi bi-speedometer2 mr-1 h5"></i>
              ${{ formatter.format(item.Valor_Presupuesto, 0) }}
            </span>
          </div>
          <div v-if="item.Valor_Presupuesto > 0">
            <CProgress 
              color="info" 
              size="xs" 
              :value="((item.Valor_Mercancia / item.Valor_Presupuesto) * 100)"/>
            <span>{{ formatter.format(((item.Valor_Mercancia / item.Valor_Presupuesto) * 100), 2) }}%</span>
          </div>
        </td>
      </template>
    </CDataTable>

    <CElementCover v-show="loading" />
  </CContainer>
</template>
<script>
  import { formatter } from '../../general'
  import { dataCostoVentasDocumentos } from "../../apiData"

  const fields = [
    {
      key: "descripcion",
      label: "Descripción"
    },
    {
      key: "valores",
      label: "Valores"
    },
    {
      key: "utilidades",
      label: "Utilidad"
    },
    {
      key: "presupuesto",
      label: "Presupuesto"
    }
  ]

  export default {
    name: 'SalesProfit',
    data() {
      return {
        formatter,
        loading: false,
        fields,
        items: [],
        page: 1,
        pageCount: 1,
        itemsPerPage: 5
      }
    },
    props: {
      initDate: String,
      endDate: String,
      reportType: String,
      utilityType: String,
      idStaffGroup: String,
      idEmployee: String
    },
    methods: {
      async getData() {
        this.loading = true;

        try {
          const parameters = {
            "Fecha_Inicial": this.initDate,
            "Fecha_Final": this.endDate,
            "Tipo_Reporte": this.reportType,
            "Tipo_Utilidad": "venta",
            "Id_GrupoPersonal": this.idStaffGroup,
            "Id_Personal": this.idEmployee
          }
          const { response } = await dataCostoVentasDocumentos(this, parameters);
          this.items = response;
        } catch(error) {
          console.log(error);
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al cargar los datos!",
            show: 5
          })
        } finally {
          this.loading = false
        }
      }
    },
    async mounted() {
      console.log(this.reportType);
      console.log(this.idEmployee);

      await this.getData()
    },
  }
</script>